//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';
import every from 'lodash/fp/every';
import template from './required-permissions-tooltip.html';

export class RequiredPermissionsTooltip {
  public permissions;

  constructor(private PermissionsService) {}

  public hasAllPermissions(): boolean {
    const hasEveryPermission = every((task) => this.PermissionsService.hasPermissionForTask(task));
    return hasEveryPermission(this.permissions);
  }
}

angular.module('curalate').component('requiredPermissionsTooltip', {
  bindings: {
    permissions: '<',
  },
  controller: [
    'PermissionsService',
    RequiredPermissionsTooltip,
  ],
  template,
  transclude: true,
});
